// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../app/assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../app/assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../app/assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../app/assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../app/assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../app/assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../app/assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../app/assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../app/assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.HashtagDetails_scroll__YMUCJ::-webkit-scrollbar {
  height: 8px;
}
.HashtagDetails_scroll__YMUCJ::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.HashtagDetails_scroll__YMUCJ::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.HashtagDetails_HashtagView__QKsdz .HashtagDetails_HashtagTitle__ppoIx {
  background-color: var(--bgColor);
  padding: 20px;
  margin-bottom: 30px;
  display: flex;
  justify-content: flex-start;
}
body[dir=rtl] .HashtagDetails_HashtagView__QKsdz .HashtagDetails_HashtagTitle__ppoIx h3 {
  margin-left: auto;
  width: -webkit-max-content;
  width: max-content;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_Loader__1g68b {
  position: fixed;
  width: 85%;
  height: 100%;
  background-color: transparent;
  z-index: 1000;
  top: 0;
  bottom: 0;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_TopBar__Uowt5 {
  display: flex;
  justify-content: space-between;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_TopBar__Uowt5 .Tweet {
  font-size: 13px !important;
  padding: 6px !important;
  text-transform: capitalize !important;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_TopBar__Uowt5 .HashtagDetails_Controls__U1hCC > *:not(:last-child) {
  -webkit-margin-end: 40px;
          margin-inline-end: 40px;
  position: relative;
  padding: 0;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_TopBar__Uowt5 .HashtagDetails_Controls__U1hCC > *:not(:last-child)::after {
  content: "";
  position: absolute;
  width: 1px;
  height: 20px;
  background-color: var(--borderColor);
}
body[dir=ltr] .HashtagDetails_HashtagView__QKsdz .HashtagDetails_TopBar__Uowt5 .HashtagDetails_Controls__U1hCC > *:not(:last-child)::after {
  right: -20px;
}
body[dir=rtl] .HashtagDetails_HashtagView__QKsdz .HashtagDetails_TopBar__Uowt5 .HashtagDetails_Controls__U1hCC > *:not(:last-child)::after {
  left: -20px;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_TopBar__Uowt5 .HashtagDetails_Controls__U1hCC > :last-child {
  padding: 0;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_downLoadButton__3P0S5 g path {
  stroke: var(--borderColor) !important;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_downLoadButton__3P0S5 g line {
  stroke: var(--borderColor) !important;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_toolBar__OKCPg {
  background-color: var(--bgColor);
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_toolBar__OKCPg .HashtagDetails_Filters__jh8Ux {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_toolBar__OKCPg .HashtagDetails_Filters__jh8Ux .HashtagDetails_Select__tUs8- {
  width: 120px;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_toolBar__OKCPg .HashtagDetails_Filters__jh8Ux .HashtagDetails_Select__tUs8-:not(:last-child) {
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_toolBar__OKCPg .HashtagDetails_Actions__bjIjZ {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_toolBar__OKCPg .HashtagDetails_Actions__bjIjZ .HashtagDetails_ActionBtn__TGwAL {
  flex-shrink: 0;
  position: relative;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_toolBar__OKCPg .HashtagDetails_Actions__bjIjZ .HashtagDetails_ActionBtn__TGwAL:not(:last-child) {
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_toolBar__OKCPg .HashtagDetails_Actions__bjIjZ .HashtagDetails_ActionBtn__TGwAL:not(:first-child)::before {
  content: "";
  width: 1px;
  height: 13px;
  background-color: var(--borderColor);
  display: block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  left: -10px;
  margin: 0 10px;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_Sentiment__ce8p5 {
  position: relative;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_Sentiment__ce8p5 > div:first-child {
  z-index: 2;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_Sentiment__ce8p5 > div:first-child p {
  font-size: 14px !important;
  text-transform: uppercase;
  line-height: 17px;
  margin-bottom: 10px;
}
body[dir=ltr] .HashtagDetails_HashtagView__QKsdz .HashtagDetails_Sentiment__ce8p5 > div:first-child p {
  font-family: "LatoBold", "CairoBold", sans-serif !important;
}
body[dir=rtl] .HashtagDetails_HashtagView__QKsdz .HashtagDetails_Sentiment__ce8p5 > div:first-child p {
  font-family: "CairoBold", "LatoBold", sans-serif !important;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_tweetsSentiment__M0Wd8 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  gap: 10px !important;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_tweetsSentiment__M0Wd8 div {
  min-width: 0;
  min-width: initial;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_tweetsSentiment__M0Wd8 .HashtagDetails_translateToggle__PP8Pz {
  align-self: baseline;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_tweetsSentiment__M0Wd8 .HashtagDetails_translateToggle__PP8Pz span[class*=MuiSwitch-switchBase] {
  top: -5px !important;
}
body[dir=ltr] .HashtagDetails_HashtagView__QKsdz .HashtagDetails_tweetsSentiment__M0Wd8 .HashtagDetails_translateToggle__PP8Pz span[class*=MuiSwitch-switchBase] {
  right: -3px;
}
body[dir=rtl] .HashtagDetails_HashtagView__QKsdz .HashtagDetails_tweetsSentiment__M0Wd8 .HashtagDetails_translateToggle__PP8Pz span[class*=MuiSwitch-switchBase] {
  left: -3px;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_tweetsSentiment__M0Wd8 .HashtagDetails_translateToggle__PP8Pz span[class*=MuiIconButton-root] {
  padding: 15px !important;
}
.HashtagDetails_HashtagView__QKsdz .HashtagDetails_tweetsSentiment__M0Wd8 .HashtagDetails_translateToggle__PP8Pz span[class*=MuiIconButton-root]:hover {
  background-color: transparent !important;
}

.apexcharts-legend-text {
  font-size: 10px !important;
}
.MuiButton-root {
  width: auto;
  font-size: 10px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/hashtags/components/HashtagDetails/HashtagDetails.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AAlDE;EACE,gCAAA;EACA,aAAA;EACA,mBAAA;EAOA,aAAA;EACA,2BAAA;AA+CJ;AArDM;EACE,iBAAA;EACA,0BAAA;EAAA,kBAAA;AAuDR;AAjDE;EACE,eAAA;EACA,UAAA;EACA,YAAA;EACA,6BAAA;EACA,aAAA;EACA,MAAA;EACA,SAAA;AAmDJ;AAjDE;EACE,aAAA;EACA,8BAAA;AAmDJ;AAhDM;EACE,0BAAA;EACA,uBAAA;EACA,qCAAA;AAkDR;AA/CI;EACE,wBAAA;UAAA,uBAAA;EACA,kBAAA;EACA,UAAA;AAiDN;AAhDM;EACE,WAAA;EACA,kBAAA;EAOA,UAAA;EACA,YAAA;EACA,oCAAA;AA4CR;AApDQ;EACE,YAAA;AAsDV;AApDQ;EACE,WAAA;AAsDV;AA/CI;EACE,UAAA;AAiDN;AA5CM;EACE,qCAAA;AA8CR;AA5CM;EACE,qCAAA;AA8CR;AA1CE;EACE,gCAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AA4CJ;AA1CI;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,cAAA;AA4CN;AA1CM;EACE,YAAA;AA4CR;AA1CQ;EACE,wBAAA;UAAA,uBAAA;AA4CV;AAvCI;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AAyCN;AAvCM;EACE,cAAA;EACA,kBAAA;AAyCR;AAvCQ;EACE,wBAAA;UAAA,uBAAA;AAyCV;AAtCQ;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;EACA,+BAAA;EACA,8BAAA;EACA,WAAA;EACA,cAAA;AAwCV;AAnCE;EACE,kBAAA;AAqCJ;AApCI;EACE,UAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;AAsCN;AArCM;ED1BF,0BAAA;EC4BI,yBAAA;EACA,iBAAA;EACA,mBAAA;AAuCR;ADpEI;EACE,2DAAA;ACsEN;ADpEI;EACE,2DAAA;ACsEN;AAzCE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,oBAAA;AA2CJ;AA1CI;EACE,YAAA;EAAA,kBAAA;AA4CN;AA1CI;EACE,oBAAA;AA4CN;AA3CM;EACE,oBAAA;AA6CR;AA5CQ;EACE,WAAA;AA8CV;AA5CQ;EACE,UAAA;AA8CV;AA3CM;EACE,wBAAA;AA6CR;AA5CQ;EACE,wCAAA;AA8CV;;AAtCE;EDrEE,0BAAA;AC+GJ;AAvCE;EACE,WAAA;EDzEA,0BAAA;ACmHJ","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.HashtagView {\n  .HashtagTitle {\n    background-color: var(--bgColor);\n    padding: 20px;\n    margin-bottom: 30px;\n    h3 {\n      #{$rtl} & {\n        margin-left: auto;\n        width: max-content;\n      }\n    }\n    display: flex;\n    justify-content: flex-start;\n  }\n  .Loader {\n    position: fixed;\n    width: 85%;\n    height: 100%;\n    background-color: transparent;\n    z-index: 1000;\n    top: 0;\n    bottom: 0;\n  }\n  .TopBar {\n    display: flex;\n    justify-content: space-between;\n\n    :global {\n      .Tweet {\n        font-size: 13px !important;\n        padding: 6px !important;\n        text-transform: capitalize !important;\n      }\n    }\n    .Controls > *:not(:last-child) {\n      margin-inline-end: 40px;\n      position: relative;\n      padding: 0;\n      &::after {\n        content: '';\n        position: absolute;\n        #{$ltr} & {\n          right: -20px;\n        }\n        #{$rtl} & {\n          left: -20px;\n        }\n        width: 1px;\n        height: 20px;\n        background-color: var(--borderColor);\n      }\n    }\n    .Controls > :last-child {\n      padding: 0;\n    }\n  }\n  .downLoadButton {\n    g {\n      path {\n        stroke: var(--borderColor) !important;\n      }\n      line {\n        stroke: var(--borderColor) !important;\n      }\n    }\n  }\n  .toolBar {\n    background-color: var(--bgColor);\n    padding: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    .Filters {\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      flex-shrink: 0;\n\n      .Select {\n        width: 120px;\n\n        &:not(:last-child) {\n          margin-inline-end: 10px;\n        }\n      }\n    }\n\n    .Actions {\n      flex-shrink: 0;\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n\n      .ActionBtn {\n        flex-shrink: 0;\n        position: relative;\n\n        &:not(:last-child) {\n          margin-inline-end: 10px;\n        }\n\n        &:not(:first-child)::before {\n          content: '';\n          width: 1px;\n          height: 13px;\n          background-color: var(--borderColor);\n          display: block;\n          position: absolute;\n          top: 50%;\n          transform: translateY(-50%);\n          -webkit-transform: translateY(-50%);\n          -moz-transform: translateY(-50%);\n          -ms-transform: translateY(-50%);\n          -o-transform: translateY(-50%);\n          left: -10px;\n          margin: 0 10px;\n        }\n      }\n    }\n  }\n  .Sentiment {\n    position: relative;\n    & > div:first-child {\n      z-index: 2;\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      background-color: rgba(#fff, 0.9);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      text-align: center;\n      flex-direction: column;\n      p {\n        @include fontSize(14);\n        text-transform: uppercase;\n        line-height: 17px;\n        margin-bottom: 10px;\n      }\n    }\n  }\n  .tweetsSentiment {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    text-align: center;\n    gap: 10px !important;\n    div {\n      min-width: unset;\n    }\n    .translateToggle {\n      align-self: baseline;\n      span[class*='MuiSwitch-switchBase'] {\n        top: -5px !important;\n        #{$ltr} & {\n          right: -3px;\n        }\n        #{$rtl} & {\n          left: -3px;\n        }\n      }\n      span[class*='MuiIconButton-root'] {\n        padding: 15px !important;\n        &:hover {\n          background-color: transparent !important;\n        }\n      }\n    }\n  }\n}\n\n:global {\n  .apexcharts-legend-text {\n    @include fontSize(10);\n  }\n  .MuiButton-root {\n    width: auto;\n    @include fontSize(10);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `HashtagDetails_scroll__YMUCJ`,
	"HashtagView": `HashtagDetails_HashtagView__QKsdz`,
	"HashtagTitle": `HashtagDetails_HashtagTitle__ppoIx`,
	"Loader": `HashtagDetails_Loader__1g68b`,
	"TopBar": `HashtagDetails_TopBar__Uowt5`,
	"Controls": `HashtagDetails_Controls__U1hCC`,
	"downLoadButton": `HashtagDetails_downLoadButton__3P0S5`,
	"toolBar": `HashtagDetails_toolBar__OKCPg`,
	"Filters": `HashtagDetails_Filters__jh8Ux`,
	"Select": `HashtagDetails_Select__tUs8-`,
	"Actions": `HashtagDetails_Actions__bjIjZ`,
	"ActionBtn": `HashtagDetails_ActionBtn__TGwAL`,
	"Sentiment": `HashtagDetails_Sentiment__ce8p5`,
	"tweetsSentiment": `HashtagDetails_tweetsSentiment__M0Wd8`,
	"translateToggle": `HashtagDetails_translateToggle__PP8Pz`
};
export default ___CSS_LOADER_EXPORT___;
